export default __webpack_public_path__ + "static/berlin-wall-ec1777c3c98ed982a8ef7e7c619996ff.jpg";